import { useEffect, type ComponentPropsWithRef } from "react";
import {
    playButtonClickSound,
    preloadButtonClickSound,
} from "../../../logic/helpers/buttonClickSound";

export interface SoundButtonProps extends ComponentPropsWithRef<"button"> {
    /** Use none when this action already owns a sound, or should stay silent. */
    clickSound?: "default" | "none";
}

/** Native button behavior with one sound per accepted user activation. */
export function SoundButton({
    clickSound = "default",
    onClick,
    type = "button",
    ...buttonProps
}: SoundButtonProps) {
    useEffect(() => {
        if (clickSound === "default") preloadButtonClickSound();
    }, [clickSound]);

    return (
        <button
            {...buttonProps}
            type={type}
            onClick={(event) => {
                onClick?.(event);
                if (
                    clickSound === "default" &&
                    (onClick !== undefined || type !== "button") &&
                    !event.defaultPrevented &&
                    !event.currentTarget.disabled &&
                    event.currentTarget.getAttribute("aria-disabled") !== "true"
                ) {
                    playButtonClickSound();
                }
            }}
        />
    );
}
